import { z } from 'zod';

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_AUDIENCE: z.string().url(),
  VITE_AUTH0_REDIRECT_URI: z.string().url(),
  VITE_AUTH0_LOGOUT_RETURN_TO: z.string().url(),
  VITE_API_BASE_URL: z.string().url(),
  VITE_SENTRY_DSN: z.string().min(1),
  VITE_SENTRY_ENVIRONMENT: z.string().default('local'),
  VITE_APP_NAME: z.string().default('QMS Grupo DIM'),
  VITE_APP_VERSION: z.string().default('0.0.0'),
  // Administrador del LMS (acceso desde el menú para quien administra usuarios o roles).
  // Opcional: sin él, el acceso no se muestra.
  // Vacía (p. ej. un ARG de build sin valor) = no configurada.
  VITE_LMS_ADMIN_URL: z.preprocess((v) => (v === '' ? undefined : v), z.string().url().optional()),
});

export type Env = z.infer<typeof envSchema>;

/**
 * Valida y normaliza un objeto de variables de entorno contra el schema.
 * Extraído como función pura para poder testearla sin depender de import.meta.env.
 */
export function loadEnvFrom(input: Record<string, unknown>): Env {
  const parsed = envSchema.safeParse(input);
  if (!parsed.success) {
    throw new Error(`Invalid VITE_* env variables: ${JSON.stringify(parsed.error.format())}`);
  }
  return parsed.data;
}

export const env = loadEnvFrom(import.meta.env);
